import { render, staticRenderFns } from "./InsectPestsAdd.vue?vue&type=template&id=2af1f972&scoped=true"
import script from "./InsectPestsAdd.vue?vue&type=script&lang=ts"
export * from "./InsectPestsAdd.vue?vue&type=script&lang=ts"
import style0 from "./InsectPestsAdd.vue?vue&type=style&index=0&id=2af1f972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1f972",
  null
  
)

export default component.exports